export const ACCOUNT_MANAGEMENT_COLLECTION_OPTIONS = {
  fields: 'eventually_due',
  requirements: {
    only: [
      'individual.first_name',
      'individual.last_name',
      'individual.email',
      'individual.phone',
      'individual.dob.day',
      'individual.dob.month',
      'individual.dob.year',
      'external_account',
      'individual.address.city',
      'individual.address.line1',
      'individual.address.postal_code',
      'individual.address.state',
      'individual.id_number',
      'individual.id_numbers.us_ssn_last_4',
      'individual.verification.*',
    ],
  },
};

export const STRIPE_SESSION_ERROR = {
  NOT_FOUND: 'NOT_FOUND',
  SERVER_ERROR: 'SERVER_ERROR',
  GATEWAY_ERROR: 'GATEWAY_ERROR',
  UNKNOWN: 'UNKNOWN',
};
